import {
  INIT_CHAT_SCREEN,
  CREATE_CHAT_HANDLER_SUCCESS,
  CREATE_CHAT_HANDLER_FAIL,
  CHANNEL_TITLE_CHANGED,
  CHANNEL_TITLE_CHANGED_FAIL,
  CHANNEL_PICTURE_CHANGED,
  CHANNEL_PICTURE_CHANGED_FAIL,
  MESSAGE_LIST_SUCCESS,
  MESSAGE_LIST_FAIL,
  SEND_MESSAGE_TEMPORARY,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  USER_BLOCK_SUCCESS,
  USER_BLOCK_FAIL,
  USER_UNBLOCK_FAIL,
  USER_UNBLOCK_SUCCESS,
  CHANNEL_EXIT_SUCCESS,
  CHANNEL_EXIT_FAIL,
  CLEAR_CHANNEL_SUCCESS,
  CLEAR_CHANNEL_FAIL,
  MESSAGE_FILE_PROGRESS,
  MESSAGE_RECEIVED,
  MESSAGE_UPDATED,
  MESSAGE_DELETED,
  CHANNEL_CHANGED,
  TYPING_STATUS_UPDATED,
  READ_RECEIPT_UPDATED
} from './../../actions/messenger/types'
import {parseUrl} from '../../scenes/SendbirdMessenger/util/index'

const INITIAL_STATE = {
  list: [],
  memberCount: 0,
  title: '',
  picture: '',
  exit: false,
  typing: '',
  progress: [],
  moreMessages: null
}

const uniqueList = list => {
  // eslint-disable-next-line no-undef
  let pathname = location.pathname.split('/')
  return list.reduce((uniqList, currentValue) => {
    if (parseUrl(currentValue.channelUrl) !== parseUrl(pathname[pathname.length - 1])) return uniqList
    let ids = uniqList.map(item => { return item.messageId })
    if (ids.indexOf(currentValue.messageId) < 0) {
      uniqList.push(currentValue)
    }
    return uniqList
  }, [])
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_CHAT_SCREEN:
      return {...state, ...INITIAL_STATE}
    case CREATE_CHAT_HANDLER_SUCCESS:
      return {...state}
    case CREATE_CHAT_HANDLER_FAIL:
      return {...state}
    case CHANNEL_TITLE_CHANGED:
      return {...state, title: action.title, memberCount: action.memberCount}
    case CHANNEL_TITLE_CHANGED_FAIL:
      return {...state}
    case USER_BLOCK_SUCCESS:
      return {...state}
    case USER_BLOCK_FAIL:
      return {...state}
    case USER_UNBLOCK_SUCCESS:
      return {...state}
    case USER_UNBLOCK_FAIL:
      return {...state}
    case CHANNEL_PICTURE_CHANGED:
      return {...state, picture: action.picture}
    case CHANNEL_PICTURE_CHANGED_FAIL:
      return {...state}
    case MESSAGE_LIST_SUCCESS:
      return {...state, list: uniqueList([...state.list, ...action.list]), moreMessages: true}
    case MESSAGE_LIST_FAIL:
      return {...state, moreMessages: action.messages}
    case SEND_MESSAGE_TEMPORARY:
      return {...state, list: [...[action.message], ...state.list]}
    case SEND_MESSAGE_SUCCESS:
      const newMessage = action.message
      const sendSuccessList = state.list.map(message => {
        if (message.reqId && newMessage.reqId && message.reqId.toString() === newMessage.reqId.toString()) {
          return newMessage
        }
        return message
      })
      return {...state, list: sendSuccessList}
    case MESSAGE_FILE_PROGRESS:
      const messageProgress = parseInt(Math.floor(action.message.loaded / action.message.total * 100))

      if (messageProgress === 100) {
        const progressList = state.progress.filter(function (item) {
          return !(item.reqId && action.reqId && item.reqId.toString() === action.reqId.toString())
        })
        return {...state, progress: progressList}
      }

      if (state.progress.length === 0) {
        const progress = [{reqId: action.reqId.toString(), progress: messageProgress}]
        return {...state, progress}
      }
      let newItem = {reqId: action.reqId.toString(), progress: messageProgress}
      let isNew = true
      const progressList = state.progress.map(item => {
        if (item.reqId === action.reqId) {
          isNew = !isNew
          return newItem
        }
        return item
      })
      if (isNew) progressList.push(newItem)
      return {...state, progress: progressList}

    case SEND_MESSAGE_FAIL:
      const newChatList = state.list.slice(1)
      return {...state, list: newChatList}
    case CHANNEL_EXIT_SUCCESS:
      return {...state, exit: true}
    case CHANNEL_EXIT_FAIL:
      return {...state, exit: false}

    case MESSAGE_RECEIVED:
      return {...state, list: uniqueList([...[action.payload], ...state.list])}
    case MESSAGE_UPDATED:
      const updatedMessage = action.payload
      const updatedList = state.list.map(message => {
        if (message.messageId === updatedMessage.messageId) {
          message = updatedMessage
        }
        return message
      })
      return {...state, list: updatedList}
    case MESSAGE_DELETED:
      const deletedList = state.list.filter(message => {
        return message.messageId.toString() !== action.payload.toString()
      })
      return {...state, list: deletedList}
    case CHANNEL_CHANGED:
      return {...state, memberCount: action.memberCount, title: action.title}
    case TYPING_STATUS_UPDATED:
      return {...state, typing: action.typing}
    case READ_RECEIPT_UPDATED:
      return {...state, list: state.list}
    case CLEAR_CHANNEL_SUCCESS:
      return {...state}
    case CLEAR_CHANNEL_FAIL:
      return {...state}
    default:
      return state
  }
}
